import React, { Component } from "react";
import Router from "next/router";
import { Card, Col, Form, Row } from "react-bootstrap";
import { IKImage, IKContext } from "imagekitio-react";
import { Alert } from "@material-ui/lab";
import { Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";

import Wizard from "../components/Forms/RaqFormikWizard";

import { userActions, enquiryActions, productActions } from "../_actions";
import {
  MobileForm,
  TabletForm,
  LaptopForm,
  AnotherGadgetForm,
} from "../components/Forms/RaqForms";
import BackDrop from "../components/BackDrop";
import Link from "next/link";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const WizardStep = ({ children }) => children;
const CustomInputComponent = ({
  field, // { name, value, onChange, onBlur }

  form: { values, touched, errors, handleChange, handleBlur }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

  ...props
}) => (
  <>
    <Form.Control
      isInvalid={!!errors[field.name]}
      isValid={touched[field.name] && !errors[field.name]}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values[field.name]}
      {...field}
      {...props}
    />
    <Form.Control.Feedback type={errors[field.name] ? "invalid" : "valid"}>
      {errors[field.name] ? errors[field.name] : "Looks good!"}
    </Form.Control.Feedback>
  </>
);

const renderStateList = (stateList) => {
  const obj = Object.entries(stateList).map(([key, value]) => ({
    key,
    value,
  }));
  return obj.map((item) => {
    return (
      <option key={item.key} value={item.key}>
        {item.value}
      </option>
    );
  });
};

class RaqMultiStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "",
      existsModel: false,
      submittedRaq: [],
    };
  }
  componentDidMount() {
    const { user } = this.props;
    if (user) {
      this.props.getProfile(user.partyId);
    }
    this.props.getRaqLaptopoptions();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { profile } = nextProps;
    const { modelData } = nextProps;
    if (profile) {
      const { address } = profile;
      const { contact_number } = profile;
      this.setState({
        firstName: profile.firstname,
        lastName: profile.lastname,
        phone: contact_number.phone_number,
        email: profile.user_login_id,
        address1: address.street_name1,
        address2: address.street_name2,
        city: address.city,
        state: address.state,
        pincode: address.pin,
      });
    }

    if (!!modelData) {
      this.setState({
        existsModel: modelData,
      });
    } else {
      this.setState({
        existsModel: false,
      });
    }
  }
  render() {
    const {
      mainCategories,
      laptopOption,
      savingEnquiry,
      saveStatus,
      stateList,
    } = this.props;
    const {
      category,
      firstName,
      lastName,
      email,
      phone,
      address1,
      address2,
      city,
      state,
      pincode,
      existsModel,
      submittedRaq,
    } = this.state;
    var raqForm;
    let deviceSchema = {};
    const commonFieldSchema = Yup.object().shape({
      model_name: Yup.string().required("Model Name is required"),
      brand: Yup.string().required("Brand is required"),
      condition: Yup.string().required("Physical condition is required"),
      warranty: Yup.string().required("Age/Warranty is required"),
      accessories: Yup.string().required("Accessories is required"),
      other_details: Yup.string().when("condition", {
        is: (value) =>
          value === "Partially defective" || value === "Fully not working",
        then: Yup.string().required("Other Details are required."),
      }),
    });
    if (category && category === "4") {
      deviceSchema = Yup.object({
        capacity: Yup.string().required(
          "Internal Storage capacity is required"
        ),
        ram: Yup.string().required("RAM is required"),
      });
      raqForm = <MobileForm />;
    } else if (category === "5") {
      deviceSchema = Yup.object({
        capacity: Yup.string().required(
          "Internal Storage capacity is required"
        ),
        screen_size: Yup.string().required("Screen Size is required"),
        ram: Yup.string().required("RAM is required"),
      });
      raqForm = <TabletForm />;
    } else if (category === "6") {
      deviceSchema = Yup.object({
        processor: Yup.string().required("Processor is required"),
        os_installed: Yup.string().required("OS is required"),
        capacity: Yup.string().required("HDD Capacity is required"),
        ram: Yup.string().required("RAM is required"),
        screen_size: Yup.string().required("Screen Size is required"),
        battery_life: Yup.string().required("Battery Life is required"),
        dedicated_graphics: Yup.string().required(
          "Dedicated Graphics is required"
        ),
        touchscreen: Yup.string().required("Touchscreen is required"),
      });
      raqForm = <LaptopForm laptopOption={laptopOption} />;
    } else if (category === "10") {
      deviceSchema = Yup.object({
        item_name: Yup.string().required("Item Name is required"),
        specs: Yup.string().required("Detail Specification required"),
      });
      raqForm = <AnotherGadgetForm />;
    } else {
      deviceSchema = Yup.object({
        category: Yup.string().required("required"),
      });
    }
    const mergedSchema = commonFieldSchema.concat(deviceSchema);
    const phoneRegExp = /^[6-9][0-9]{9}$/;
    return (
      <>
        <div>
          {saveStatus ? (
            <Alert severity="success">
              Thank you for choosing to sell your device in an
              environmentally and socially responsible manner. Our team
              member shall be reverting to you within the next 48 - 72
              hours.
            </Alert>
          ) : savingEnquiry ? (
            <BackDrop />
          ) : (
            <Wizard
              initialValues={{
                firstname: firstName,
                lastname: lastName,
                email: email,
                mobile_no: phone,
                street_name1: address1,
                street_name2: address2,
                address_city: city,
                address_pin: pincode,
                zone_id: state,
                category: 4,
                item_name: "",
                model_name: "",
                brand: "",
                processor: "",
                os_installed: "",
                capacity: "",
                ram: "",
                condition: "",
                warranty: "",
                screen_size: "",
                battery_life: "",
                accessories: "",
                picture: "",
                specs: "",
                dedicated_graphics: "",
                touchscreen: "",
                other_details: "",
              }}
              onSubmit={async (values) =>
                sleep(300).then(() => {
                  if (values.category) {
                    var formData = new FormData();
                    for (let [key, value] of Object.entries(values)) {
                      formData.append(key, value);
                    }
                    formData.append("files", values.picture);
                    this.props.submitRaq(formData);
                  } else {
                    Router.reload();
                  }
                })
              }
            >
              <WizardStep
                onSubmit={(values) => {
                  this.setState({ category: values.category });
                }}
                validationSchema={Yup.object({
                  category: Yup.string().required(
                    "Please select one category"
                  ),
                })}
              >
                <h4 className="fw-600 text-dark mb-2">Select One Category</h4>
                <div>
                  <div className="row chkfrm">
                    {mainCategories &&
                      mainCategories.map((category, i) =>
                        category.display_in_homepage ? (
                          <>
                            <div className="col-md-6 col-lg-3 mb-lg-0 mb-md-4 reqfrm">
                              <label className="image-radio" key={i}>
                                <Field
                                  name="category"
                                  value={category.id}
                                  type="radio"
                                >
                                  {({
                                    field, // { name, value, onChange, onBlur }

                                    form: { setFieldValue, submitForm }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                  }) => (
                                    <>
                                      <input
                                        type="radio"
                                        {...field}
                                        onChange={(e) => {
                                          setFieldValue(
                                            "category",
                                            e.target.value
                                          );
                                          submitForm();
                                        }}
                                      />
                                      <IKContext urlEndpoint="https://ik.imagekit.io/budli">
                                        <IKImage
                                          path={category.image}
                                          alt={category.name}
                                          title={category.name}
                                          loading="lazy"
                                          lqip={{ active: true }}
                                        />
                                      </IKContext>
                                      <br />
                                      {category.name}
                                    </>
                                  )}
                                </Field>
                              </label>
                            </div>
                          </>
                          
                        ) : (
                          ""
                        )
                      )}
                    <ErrorMessage
                      className="error"
                      component="div"
                      name="category"
                    />
                  </div>
                </div>
              </WizardStep>
              <WizardStep
                onSubmit={(values) => {
                  this.props.getExistsModel(
                    values.model_name,
                    values.brand
                  );
                  this.setState({
                    submittedRaq: values,
                  });
                }}
                validationSchema={mergedSchema}
              >
                <h4 className="fw-600 text-dark mb-2">Device Details</h4>
                <div className="row chkfrm">{raqForm}</div>
              </WizardStep>
              <WizardStep
                onSubmit={(values) => {
                  console.log("Step1 onSubmit", values);
                }}
                validationSchema={Yup.object({
                  firstname: Yup.string().required("required"),
                  lastname: Yup.string().required("required"),
                  email: Yup.string().required("required").email(),
                  mobile_no: Yup.string()
                    .length(
                      10,
                      "Mobile number must be exactly 10 characters"
                    )
                    .required("required"),
                  street_name1: Yup.string().required("required"),
                  address_city: Yup.string().required("required"),
                  zone_id: Yup.string().required("required"),
                  address_pin: Yup.string().required("required"),
                })}
              >
                <h4 className="fw-600 text-dark mb-2">Contact Details</h4>
                <div className="row chkfrm">
                  <Form.Group as={Col} md="6">
                    <Form.Label>First Name</Form.Label>
                    <Field
                      type="text"
                      id="firstname"
                      name="firstname"
                      placeholder="First Name"
                      component={CustomInputComponent}
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Last Name</Form.Label>
                    <Field
                      component={CustomInputComponent}
                      id="lastname"
                      name="lastname"
                      placeholder="Last Name"
                      type="text"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Email</Form.Label>
                    <Field
                      component={CustomInputComponent}
                      id="email"
                      name="email"
                      placeholder="youremail@example.com"
                      type="email"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Mobile Number</Form.Label>
                    <Field
                      component={CustomInputComponent}
                      id="mobile_no"
                      name="mobile_no"
                      placeholder="Mobile Number"
                      type="text"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Address Line 1</Form.Label>
                    <Field
                      component={CustomInputComponent}
                      id="street_name1"
                      name="street_name1"
                      placeholder="Address Line 1"
                      type="text"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Address Line 2</Form.Label>
                    <Field
                      component={CustomInputComponent}
                      id="street_name2"
                      name="street_name2"
                      placeholder="Address Line 2"
                      type="text"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>City</Form.Label>
                    <Field
                      component={CustomInputComponent}
                      id="address_city"
                      name="address_city"
                      placeholder="City"
                      type="text"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>Pincode</Form.Label>
                    <Field
                      component={CustomInputComponent}
                      name="address_pin"
                      placeholder="Pin Code"
                      type="text"
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>State</Form.Label>
                    <Field id="zone_id" name="zone_id">
                      {({
                        field, // { name, value, onChange, onBlur }

                        form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

                        meta,
                      }) => (
                        <>
                          <Form.Control
                            as="select"
                            {...field}
                            isInvalid={!!errors[field.name]}
                            isValid={
                              touched[field.name] && !errors[field.name]
                            }
                            value={values.zone_id}
                          >
                            <option value="">Select One</option>
                            {stateList && renderStateList(stateList)}
                          </Form.Control>
                          <Form.Control.Feedback
                            type={errors[field.name] ? "invalid" : "valid"}
                          >
                            {errors[field.name]
                              ? errors[field.name]
                              : "Looks good!"}
                          </Form.Control.Feedback>
                        </>
                      )}
                    </Field>
                  </Form.Group>
                </div>
              </WizardStep>
              {existsModel && (
                <WizardStep>
                  <h4 className="fw-600 text-dark mb-2">Request A Price Details</h4>
                  <div className="row chkfrm">
                    {submittedRaq.item_name ? (
                      <Form.Group as={Col} md="6">
                        <strong>Item Name:</strong> {submittedRaq.item_name}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    <Form.Group as={Col} md="6">
                      <strong>Model Name:</strong> {submittedRaq.model_name}
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <strong>Brand:</strong> {submittedRaq.brand}
                    </Form.Group>
                    {submittedRaq.processor ? (
                      <Form.Group as={Col} md="6">
                        <strong>Processor:</strong> {submittedRaq.processor}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    {submittedRaq.os_installed ? (
                      <Form.Group as={Col} md="6">
                        <strong>OS Installed:</strong>{" "}
                        {submittedRaq.os_installed}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    <Form.Group as={Col} md="6">
                      <strong>Internal Storage:</strong>{" "}
                      {submittedRaq.capacity}
                    </Form.Group>
                    {submittedRaq.ram ? (
                      <Form.Group as={Col} md="6">
                        <strong>RAM:</strong> {submittedRaq.ram}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    <Form.Group as={Col} md="6">
                      <strong>Condition:</strong> {submittedRaq.ram}
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <strong>Age/Warranty:</strong> {submittedRaq.warranty}
                    </Form.Group>
                    {submittedRaq.screen_size ? (
                      <Form.Group as={Col} md="6">
                        <strong>Screen Size:</strong>{" "}
                        {submittedRaq.screen_size}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    {submittedRaq.battery_life ? (
                      <Form.Group as={Col} md="6">
                        <strong>Battery Life:</strong>{" "}
                        {submittedRaq.battery_life}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    {submittedRaq.specs ? (
                      <Form.Group as={Col} md="6">
                        <strong>Specifications:</strong>{" "}
                        {submittedRaq.specs}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    <Form.Group as={Col} md="6">
                      <strong>Accessories:</strong>{" "}
                      {submittedRaq.accessories}
                    </Form.Group>
                    {submittedRaq.dedicated_graphics ? (
                      <Form.Group as={Col} md="6">
                        <strong>Dedicated Graphics:</strong>{" "}
                        {submittedRaq.dedicated_graphics}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    {submittedRaq.touchscreen ? (
                      <Form.Group as={Col} md="6">
                        <strong>Touchscreen:</strong>{" "}
                        {submittedRaq.touchscreen}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                    {submittedRaq.other_details ? (
                      <Form.Group as={Col} md="6">
                        <strong>Other details:</strong>{" "}
                        {submittedRaq.other_details}
                      </Form.Group>
                    ) : (
                      ""
                    )}
                  </div>
                  <Row>
                    <Col>
                      Guess your product is already listed on our site,
                      which entitles you to an instant quote.
                      <br />
                      Is your product one of these?
                    </Col>
                  </Row>
                  <Row>
                    {existsModel.map((model, i) => {
                      return (
                        <Col key={i}>
                          {model.category.id === "6" &&
                          model.brand.slug !== "apple-macbook" ? (
                            <Link href={`/${model.category.slug}/other-laptop`} legacyBehavior>
                              {model.name}
                            </Link>
                          ) : (
                            <Link
                              href={`/${model.category.slug}/${model.brand.slug}/${model.slug}`}
                              legacyBehavior>
                              {model.name}
                            </Link>
                          )}

                          {}
                        </Col>
                      );
                    })}
                  </Row>
                  <Row>
                    <Col>
                      (click on your product above)
                      <br /> If not, then Submit.
                    </Col>
                  </Row>
                </WizardStep>
              )}
            </Wizard>
          )}
        </div>
      </>    
    );
  }
}

const mapState = (state) => ({
  profile: state.users.profile,
  laptopOption: state.enquiries.laptopOption,
  savingEnquiry: state.enquiries.savingEnquiry,
  saveStatus: state.enquiries.saveStatus,
  modelData: state.catalog.products.modelData,
});

const actionCreators = {
  getProfile: userActions.getProfile,
  getRaqLaptopoptions: enquiryActions.getRaqLaptopoptions,
  submitRaq: enquiryActions.submitRaq,
  getExistsModel: productActions.getExistsModel,
};

export default connect(mapState, actionCreators)(RaqMultiStep);
